// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nodata_img_div{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
    margin: 30px 0 0 0;
}

.tableau_table{
    border-collapse: collapse;
    min-width: 100%;
    table-layout: fixed;
}

.tableau_body:before {
    content: "@";
    display: block;
    line-height: 10px;
    text-indent: -99999px;
}

.tableau_head{
    width: 100%;
}

.tableau_head_item_th:first-child {
    border-radius: 10px 0 0 10px;
}

.tableau_head_item_th:last-child {
    border-radius: 0 10px 10px 0;
}

.tableau_head_item_th {
    background-color: #F2F3FC;
    padding: 20px 10px;
    text-align: left;
}

.tableau_div_flex{
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
}

.tableau_pagination{
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    gap: 10px;
    padding: 20px 0 0 0;
}


.button_nextPage{
    padding: 15px 15px;
    width: max-content;
    font-weight: bold;
    border-radius: 10px;
    background-color: #2B64F5;
    color: white;
}

.actualPage{
    background-color: #F2F3FC;
    padding: 15px 15px;
    width: max-content;
    font-weight: bold;
    border-radius: 10px;
    color: #2B64F5;
    border: solid 1px #2B64F5;
}

.pointer {
    cursor: pointer;
}

.tableau_head_item_th, .tableau_body_item {
    width: calc(100% / n-1); 
    overflow: hidden;     
    text-overflow: ellipsis; 
    white-space: nowrap; 
}

.tableau_first_line_summup {
    font-weight: 800;
}

.tableau_container {
    overflow-x: auto;
}

@media (max-width: 768px) {
    .tableau_table {
        min-width: 600px;  
    }
}`, "",{"version":3,"sources":["webpack://./src/components/DataComponents/Tableau/tableau.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".nodata_img_div{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    margin: 30px 0 0 0;\n}\n\n.tableau_table{\n    border-collapse: collapse;\n    min-width: 100%;\n    table-layout: fixed;\n}\n\n.tableau_body:before {\n    content: \"@\";\n    display: block;\n    line-height: 10px;\n    text-indent: -99999px;\n}\n\n.tableau_head{\n    width: 100%;\n}\n\n.tableau_head_item_th:first-child {\n    border-radius: 10px 0 0 10px;\n}\n\n.tableau_head_item_th:last-child {\n    border-radius: 0 10px 10px 0;\n}\n\n.tableau_head_item_th {\n    background-color: #F2F3FC;\n    padding: 20px 10px;\n    text-align: left;\n}\n\n.tableau_div_flex{\n    display: flex;\n    flex-direction: row;\n    gap: 5px;\n    align-items: center;\n}\n\n.tableau_pagination{\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n    align-items: center;\n    gap: 10px;\n    padding: 20px 0 0 0;\n}\n\n\n.button_nextPage{\n    padding: 15px 15px;\n    width: max-content;\n    font-weight: bold;\n    border-radius: 10px;\n    background-color: #2B64F5;\n    color: white;\n}\n\n.actualPage{\n    background-color: #F2F3FC;\n    padding: 15px 15px;\n    width: max-content;\n    font-weight: bold;\n    border-radius: 10px;\n    color: #2B64F5;\n    border: solid 1px #2B64F5;\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n.tableau_head_item_th, .tableau_body_item {\n    width: calc(100% / n-1); \n    overflow: hidden;     \n    text-overflow: ellipsis; \n    white-space: nowrap; \n}\n\n.tableau_first_line_summup {\n    font-weight: 800;\n}\n\n.tableau_container {\n    overflow-x: auto;\n}\n\n@media (max-width: 768px) {\n    .tableau_table {\n        min-width: 600px;  \n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
